module.exports = __webpack_public_path__ + "static/media/selected.f3ba01cd.svg";